var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Detalle coordinador" },
          on: { cerrar: _vm.handlePopUp }
        },
        [
          _c("div", { staticClass: "numero_sim" }, [
            _c(
              "div",
              { staticClass: "btn-editar" },
              [
                _c("v-btn", { on: { click: _vm.handleAdd } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        Object.keys(_vm.data).length === 0
                          ? "Guardar"
                          : "Guardar Cambios"
                      ) +
                      "\n        "
                  )
                ])
              ],
              1
            )
          ])
        ]
      ),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos, "validar-paso": false },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c("br"),
      _c(
        "div",
        { attrs: { align: "center" } },
        [
          _c(
            "v-flex",
            { attrs: { md10: "" } },
            [
              _c(
                "v-card",
                { staticClass: "rounded-card" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      staticClass: "col-md-12",
                      attrs: { "lazy-validation": "" }
                    },
                    [
                      _c(
                        "v-container",
                        {
                          attrs: {
                            "grid-list-md": "",
                            "pt-30": "",
                            "px-40": "",
                            "pb-50": ""
                          }
                        },
                        [
                          _c(
                            "FormFieldsContainer",
                            {
                              attrs: {
                                titulo:
                                  Object.keys(_vm.data).length === 0
                                    ? "Crear Coordinador"
                                    : "Editar Coordinador"
                              }
                            },
                            [
                              _vm._t("prependInformacionGeneral"),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    class: { "red--text": _vm.invalidName },
                                    attrs: {
                                      label: "Nombre Coordinador",
                                      error: _vm.invalidName,
                                      disabled: _vm.anulado
                                    },
                                    on: { input: _vm.validateName },
                                    model: {
                                      value: _vm.formFields.coorname.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.coorname,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.coorname.value"
                                    }
                                  }),
                                  _vm.invalidName
                                    ? _c(
                                        "div",
                                        { staticClass: "alerta--error" },
                                        [
                                          _c("span", [_vm._v("*")]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.messageName) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    class: { "red--text": _vm.invalidLastName },
                                    attrs: {
                                      label: "Apellido Coordinador",
                                      error: _vm.invalidLastName,
                                      disabled: _vm.anulado
                                    },
                                    on: { input: _vm.validateLastName },
                                    model: {
                                      value: _vm.formFields.coorapellido.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.coorapellido,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.coorapellido.value"
                                    }
                                  }),
                                  _vm.invalidLastName
                                    ? _c(
                                        "div",
                                        { staticClass: "alerta--error" },
                                        [
                                          _c("span", [_vm._v("*")]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.messageLastName) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label:
                                        Object.keys(_vm.data).length === 0
                                          ? "Fecha De Registro"
                                          : "Fecha Modificación",
                                      disabled: ""
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.coorfecha_alta.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.coorfecha_alta,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.coorfecha_alta.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      label: "Estado",
                                      items: _vm.opciones,
                                      "item-text": "value",
                                      "item-value": "id"
                                    },
                                    model: {
                                      value: _vm.formFields.coorbaja.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.coorbaja,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.coorbaja.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      label: "Tipo",
                                      items: _vm.tipo,
                                      "item-text": "value",
                                      "item-value": "id",
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.formFields.coortipo.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.coortipo,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.coortipo.value"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogPopUp,
          titulo: "Confirmación",
          mensaje:
            "Al cerrar esta ventana toda la información\n      " +
            (Object.keys(_vm.data).length === 0 ? "ingresada" : "editada") +
            "\n      se perderá.\n      ¿Está seguro que desea cerrar sin guardar?",
          textoBtnSi: _vm.$t("No Guardar"),
          textoBtnNo: _vm.$t(
            "" +
              (Object.keys(_vm.data).length === 0
                ? "Continuar Creando"
                : "Continuar Editando")
          )
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.showPopuP($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }